import { useEffect } from 'react';

import { RealtimeCallback, RealtimeService } from 'shared/lib/realtime';

type RealtimeAssignmentsParams = {
  assignmentAssignedCallback: RealtimeCallback;
  assignmentUpdatedCallback: RealtimeCallback;
  classesKeys: string[];
};

export const useRealtimeAssignments = ({
  assignmentAssignedCallback,
  assignmentUpdatedCallback,
  classesKeys,
}: RealtimeAssignmentsParams) => {
  useEffect(() => {
    if (!classesKeys.length) return;

    RealtimeService.subscribeToAssignments(
      assignmentAssignedCallback,
      assignmentUpdatedCallback,
      classesKeys,
    );

    return () => {
      RealtimeService.unsubscribeFromAssignments();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classesKeys]);
};
